import type { CommunityKpi, CommunityTimePeriod } from '@/mocks/communityAnalytics';
import { communityTimePeriodLabels } from '@/mocks/communityAnalytics';

interface CommunityKpiCardProps {
  kpi: CommunityKpi;
  timePeriod: CommunityTimePeriod;
}

const trendIcons: Record<string, string> = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  flat: 'ri-subtract-line',
};

const trendColors: Record<string, string> = {
  up: 'text-emerald-500 bg-emerald-50',
  down: 'text-red-500 bg-red-50',
  flat: 'text-foreground-400 bg-foreground-100',
};

const colorMap: Record<string, string> = {
  emerald: 'bg-emerald-50 text-emerald-600',
  sky: 'bg-sky-50 text-sky-600',
  violet: 'bg-violet-50 text-violet-600',
  rose: 'bg-rose-50 text-rose-600',
  amber: 'bg-amber-50 text-amber-600',
  orange: 'bg-orange-50 text-orange-600',
  indigo: 'bg-indigo-50 text-indigo-600',
};

export default function CommunityKpiCard({ kpi, timePeriod }: CommunityKpiCardProps) {
  const periodData = kpi[timePeriod];

  return (
    <div className="bg-background-50 rounded-xl border border-background-200 p-4 hover:border-background-300/80 transition-colors">
      <div className="flex items-center justify-between mb-3">
        <span className="text-foreground-400 text-[11px] font-medium">{kpi.label}</span>
        <div className={`w-8 h-8 rounded-lg flex items-center justify-center ${colorMap[kpi.color] || 'bg-foreground-100 text-foreground-400'}`}>
          <i className={`${kpi.icon} text-sm`}></i>
        </div>
      </div>

      <div className="flex items-baseline gap-1.5 mb-1.5">
        <span className="text-foreground-950 text-2xl font-bold tracking-tight">
          {periodData.value.toLocaleString()}
        </span>
        {kpi.unit && (
          <span className="text-foreground-400 text-[11px]">{kpi.unit}</span>
        )}
      </div>

      <div className="flex items-center gap-2">
        <span className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded-full text-[9px] font-semibold ${trendColors[periodData.trend]}`}>
          <i className={`${trendIcons[periodData.trend]} text-[8px]`}></i>
          {periodData.trendLabel}
        </span>
        <span className="text-foreground-400 text-[10px]">vs período anterior</span>
      </div>
    </div>
  );
}